import { render, staticRenderFns } from "./ReenviarCorreo.vue?vue&type=template&id=757de5f6"
import script from "./ReenviarCorreo.vue?vue&type=script&lang=js"
export * from "./ReenviarCorreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports